



























import { Component, Prop, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RewardsDisclaimer from '@/components/molecules/RewardsDisclaimer/RewardsDisclaimer.vue';

import { IBusinessType } from '@/models/business';
import DateUtils from '@/utils/DateUtils';

@Component({
  components: {
    FilledButton,
    RewardsDisclaimer
  }
})
export default class Introduction extends Vue {
  @Prop() rewardsType!: IBusinessType.ONLINE | IBusinessType.INSTORE;
  @Prop() activeRewards!: boolean;
  @Prop() loading!: boolean;

  get tPrefix() {
    return `modals.toggleRewards.${
      this.activeRewards ? 'activation' : 'deactivation'
    }`;
  }

  get tPrefixType() {
    return `${this.tPrefix}.${this.rewardsType}`;
  }

  get date() {
    return DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true
    });
  }

  onSecondaryClick() {
    if (this.activeRewards) {
      this.$emit('close');
      return;
    }
    this.$emit('finish');
  }

  onPrimaryClick() {
    if (this.activeRewards) {
      this.$emit('finish', true);
      return;
    }
    this.$emit('close');
  }
}
